import axios from "axios"
import { env } from '../constants'

/* LIST */
export const list = data => {
    const uri = `${env.startpoint}/admin/organization/list`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}


/* CREATE */
export const create = data => {
    const uri = `${env.startpoint}/admin/organization/create`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* PREPARE */
export const prepare = () => {
    const uri = `${env.startpoint}/admin/organization/prepare`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(data => data.response)
}

/* VIEW */
export const view = data => {
    const uri = `${env.startpoint}/admin/organization/view`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* EDIT */
export const edit = data => {
    const uri = `${env.startpoint}/admin/organization/edit`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* CHANGE STATUS */
export const status = data => {
    const token = localStorage.getItem("token")
    const uri = `${env.startpoint}/admin/organization/status`
    const headers = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }
    return axios.post(uri, data, headers).then(response => response).catch(error => error.response)
}

/* EDIT */
export const remove = data => {
    const uri = `${env.startpoint}/admin/organization/remove`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* REMOVE SERVICE */
export const removeService = data => {
    const uri = `${env.startpoint}/admin/organization/remove-service`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* ADD SERVICE */
export const addService = data => {
    const uri = `${env.startpoint}/admin/organization/add-service`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}




/* SET CITY */
export const setCity = data => {
    const uri = `${env.startpoint}/admin/organization/set-city`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* TOGGLE CATEGORY */
export const toggleCategory = data => {
    const uri = `${env.startpoint}/admin/organization/toggle-category`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* REMOVE IMAGE */
export const removeImage = data => {
    const uri = `${env.startpoint}/admin/organization/remove-image`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}


/* UPLOAD IMAGE */
export const uploadImage = data => {
    const uri = `${env.startpoint}/admin/organization/upload-image`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* DETAILS */
export const details = data => {
    const uri = `${env.startpoint}/admin/organization/details`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* EXTEND SUBSCRIPTION */
export const extendSubscription = data => {
    const uri = `${env.startpoint}/admin/organization/subscription/extend`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* CHANGE SUBSCRIPTION STATUS */
export const subscriptionStatus = data => {
    const uri = `${env.startpoint}/admin/organization/subscription/status`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* SET SUBSCRIPTION PRICE */
export const subscriptionPrice = data => {
    const uri = `${env.startpoint}/admin/organization/subscription/price`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* BOOKINGS OF THE ORGANIZATION */
export const bookings = data => {
    const uri = `${env.startpoint}/admin/organization/bookings`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* GET SERVICE */
export const getService = data => {
    const uri = `${env.startpoint}/admin/organization/service/get`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* SAVE SERVICE */
export const saveService = data => {
    const uri = `${env.startpoint}/admin/organization/service/save`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* ARCHIVE SERVICE */
export const archiveService = data => {
    const uri = `${env.startpoint}/admin/organization/service/archive`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}
